import axiosInst from '../../libs/axios/axios'
const moment = require('moment')
import i18n from '../../i18n/i18n'
const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  alarmData: {},
  filters: {
    apiary:null,
    hive:null,
    search:null
  }
}
const getters = {
  returnAlarmData (state) {
    return state.alarmData
  },
  alarmFilters (state) {
    return state.filters
  }
}
const mutations = {
  alarmData (state, info) {
    state.alarmData = info
  },
  filters (state, info) {
    if (info.type === 'apiary') {
      state.filters.apiary = info.data
    }
    if (info.type === 'hive') {
      state.filters.hive = info.data
    }
    if (info.type === 'search') {
      state.filters.search = info.data
    }
  }
}
const actions = {
  getAlarmFilters (store, filters) {
    store.commit('filters', filters)
  },
  getAlarmList (store, params) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/alarm/${  params}`)
        .then(response => {
          const alarmData = []
          if (response.data) {
            response.data.results.map((value) => {
              alarmData.push({
                'id': value.id,
                'hive': value.hive.name,
                'apiary': value.hive.apiary && value.hive.apiary.name ? value.hive.apiary.name : '-',
                'data_type': value.type === 0 ? i18n.t('rules.new.DataTypeOptions.Temperature') : value.type === 1 ? i18n.t('rules.new.DataTypeOptions.Humidity') : i18n.t('rules.new.DataTypeOptions.Vibration'),
                'var_value': value.type === 2 ? '-' : value.record_value,
                'created_at': value.created_at ? moment(value.created_at).format('DD/MM/YYYY HH:mm:ss') : ''
              })

            })
            store.commit('alarmData', alarmData)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPreviousNextAlarmList (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(info)
        .then(response => {
          const alarmData = []
          if (response.data) {
            response.data.results.map((value) => {
              alarmData.push({
                'id': value.id,
                'hive': value.hive.name,
                'apiary': value.hive.apiary && value.hive.apiary.name ? value.hive.apiary.name : '-',
                'data_type': value.type === 0 ? i18n.t('rules.new.DataTypeOptions.Temperature') : value.type === 1 ? i18n.t('rules.new.DataTypeOptions.Humidity') : i18n.t('rules.new.DataTypeOptions.Vibration'),
                'var_value': value.type === 2 ? '-' : value.record_value,
                'created_at': value.created_at ? moment(value.created_at).format('DD/MM/YYYY HH:mm:ss') : ''
              })

            })
            store.commit('alarmData', alarmData)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAlarmAndRulesCount () {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/user/info/`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteAlarm (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.delete(`${state.rootUrl  }/api/alarm/${data.id}/`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
